import React, { useEffect } from 'react'
import { Button, Container, Selection } from './styles'
import { BabyTimelineLabel } from '../Label'
import { IconComponent } from '~/assets/icons/component'
import { Radio } from '~/components/shared'
import { Child } from '~/interfaces'

interface IProps {
  babies: Child[]
  babiesPeriodLabel: string
  indexSelectedBaby: string
  isMultiplePregnancy: boolean
  selectedBaby: number | null
  isActive: boolean
  onClick: () => void
  openBabySelector: boolean
  onSelectBaby: (childId: number) => void
}

export const BabySelector = ({
  babies,
  babiesPeriodLabel,
  indexSelectedBaby,
  isMultiplePregnancy,
  selectedBaby,
  isActive,
  onClick,
  openBabySelector,
  onSelectBaby
}: IProps): JSX.Element => {
  const babySelectorRef = React.useRef<HTMLDivElement>(null)

  useEffect(() => {
    const closeBabySelector = (event: MouseEvent) => {
      if (babySelectorRef.current && !babySelectorRef.current.contains(event.target as Node)) {
        onClick()
      }
    }

    if (openBabySelector) {
      document.addEventListener('click', closeBabySelector)
    } else {
      document.removeEventListener('click', closeBabySelector)
    }

    return () => {
      document.removeEventListener('click', closeBabySelector)
    }
  }, [onClick, openBabySelector])

  return (
    <Container ref={babySelectorRef} onClick={onClick}>
      <BabyTimelineLabel isActive={isActive}>{`${babiesPeriodLabel} ${indexSelectedBaby}`}</BabyTimelineLabel>
      {isMultiplePregnancy && (
        <>
          <OpenBabySelectorButton openSelector={openBabySelector} />
          <BabyListOptionsToSelect
            babies={babies}
            selectedBaby={selectedBaby}
            babiesPeriodLabel={babiesPeriodLabel}
            show={openBabySelector}
            onSelect={onSelectBaby}
          />
        </>
      )}
    </Container>
  )
}

interface IOpenBabySelectorButtonProps {
  openSelector: boolean
}

export const OpenBabySelectorButton = ({ openSelector }: IOpenBabySelectorButtonProps): JSX.Element => (
  <Button openSelector={openSelector}>
    <IconComponent name="chevronDown" />
  </Button>
)

interface IBabyListOptionsToSelectProps {
  babies: Child[]
  selectedBaby: number | null
  babiesPeriodLabel: string
  show: boolean
  onSelect: (childId: number) => void
}

export const BabyListOptionsToSelect = ({
  babies,
  selectedBaby,
  babiesPeriodLabel,
  show,
  onSelect
}: IBabyListOptionsToSelectProps): JSX.Element => {
  const hasNoBabies = !babies || babies.length < 1
  if (hasNoBabies) return <></>

  return (
    <Selection show={show}>
      <ul>
        {babies.map((child, index) => (
          <li key={index}>
            <Radio
              id={`baby-${index}`}
              name={'radio'}
              label={`${babiesPeriodLabel} ${index + 1}`}
              checked={selectedBaby === child.id}
              onChange={() => onSelect(child.id)}
            />
          </li>
        ))}
      </ul>
    </Selection>
  )
}
